import React, { useContext } from 'react';

// import { useTranslation } from 'react-i18next';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';
import DataController from '@/lib/DataController';

import Umrli from '@/models/groblja/umrli';
import DCTable from '@/ui/Table/DCTable';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import GeneralGrobljaDialog from '../GeneralGrobljaDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';

const RegistarUmrlihPage = () => {
  // const { t } = useTranslation();

  const dc = new DataController(Umrli);

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.umrli_history',
        view: 'history',
        customPath: `${Umrli.apiPath}/${id}/history`,
        tableId: 'umrli-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  return (
    <AppPage titlett="groblja:titles.reg_umrlih" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <DCTable
        allowRowAction={allowRowAction}
        onRowAction={handleRowAction}
        dc={dc}
        title="groblja:titles.reg_umrlih"
        allowSelection="one"
        allowAdd
        allowEdit
        // allowDelete
        allowColumnPicker
        allowFilter
        dialogComponent={GeneralGrobljaDialog}
        allowShowDeleted
        allowDocumentButton
        allowExport
      />
    </AppPage>
  );
};

export default RegistarUmrlihPage;
